import axios from 'axios'
// import { Message } from 'element-ui'
import store from '@/store'
// import router from '@/router'
import { getToken, getRefreshToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 1000 * 60 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log(getToken())
    if (getToken()) {
      config.headers['Authorization'] = getToken()
      config.headers['refresh_token'] = getRefreshToken()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log("axios config",error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => response,

  error => {
    console.log('err ->' + error) // for debug

    if (error.response != undefined) {
      let response = error.response;
      if (response.status == "401") {
        // if(router)
        // store
        //   .dispatch("logout")
        //   .then(() => {
        //     router.push({ path: this.redirect || "/" });
        //   })
        //   .catch(() => {
        //   });
      }

    }

    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)



export default service
